import { useQuery } from '@tanstack/react-query';
import axiosService from '../services/axios.service';
import { PaginatedResponse } from '../../../shared/types';

export interface PublicCrewDTO {
    name: string;
    slug: string;
    description: string;
    headerImage?: string;
    status: string;
    isPublic: boolean;
    autoJoin: boolean;
    memberCount?: number;
}

export const usePublicCrews = (page: number = 1, limit: number = 10, search: string = '') => {
    return useQuery({
        queryKey: ['public-crews', page, limit, search],
        queryFn: async () => {
            const response = await axiosService.get<PaginatedResponse<PublicCrewDTO>>(
                '/c/public',
                {
                    params: {
                        page,
                        limit,
                        search
                    }
                }
            );
            return response.data;
        }
    });
};
